import { Wrench } from "lucide-react";

const ITEMS = [
  "Fırınlı Oto Boya",
  "Kaporta & Şasi",
  "Boyasız Göçük (PDR)",
  "Mekanik Bakım",
  "Oto Elektrik",
  "Cam Tamiri",
  "Plastik & Tampon",
  "Radyatör",
  "Mobil Onarım",
  "Yol Yardım",
];

const Row = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="whitespace-nowrap px-7 font-condensed text-2xl font-bold uppercase tracking-wide text-slate-800 lg:text-3xl">
          {t}
        </span>
        <Wrench className="h-5 w-5 shrink-0 text-brand" strokeWidth={2.4} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="service-marquee" className="overflow-hidden border-y border-slate-200 bg-white py-5">
    <div className="marquee-track">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);

export default Marquee;
